import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { Role } from 'src/app/models/um/organization';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-um-user-map-user-view-modal',
  templateUrl: './um-user-map-user-view-modal.component.html',
  styleUrls: ['./um-user-map-user-view-modal.component.scss']
})
export class UmUserMapUserViewModalComponent implements OnInit {
@Input() public Content: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  roles: Role[];
  selectedroles: Role[];
  selectedroleids: string[];
  availableroles: Role[];
  availableroleids: string[];
  changedroles: Role[];
  searchFilter: string="";
  selectedCount:number=0;
  constructor(
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private summaryService: UmSummaryService,
    private commonservice: CommonService,
  ) {
  }

  ngOnInit() {
    this.getRoles();
  }
  getRoles() {
    this.summaryService.getActiveRole().subscribe(summary => {
      let Roles= summary;
     
      this.roles=[];
      Roles.forEach(element => {
        if(this.Content.content.selectedIds.indexOf(element.ID)==-1)
        {
            element["IsMarked"]=false;
            this.roles.push(element);
        }
      });
    });
  }
  
  CancelPopup() { 
    this.modalRef.dismiss();
  }

  SaveRoles()
  { 
    debugger;
    let selectedIds = [];
    if (this.roles.length > 0) {
      selectedIds = this.roles.filter(function (a) {
        return (a["IsMarked"] == true)
      });
    }
    if (selectedIds.length == 0) {
      this.commonservice.ValidationBanner("Please select atleast one User Role");
    }
    else {
      //this.action.next(selectedIds);
      this.modalRef.close(selectedIds);
    }
  }

  collectRoles(roleid) {
    this.selectedCount=0;
    this.roles.forEach((item: any) => {
      if (item.ID == roleid) {
        if (item.IsMarked)
          item.IsMarked = false;
        else
          item.IsMarked = true;
      }
      if(item.IsMarked==true)
      {
        this.selectedCount=this.selectedCount+1;
      }
    });
  }
}
